/**
 * Utilidades para gestión de SEO y meta tags
 *
 * Lógica de idioma SEO:
 * - Si el idioma es EN o CA → usar catalán para SEO
 * - Si el idioma es ES → usar español para SEO
 */

/**
 * Determina el idioma a usar para SEO basándose en el idioma actual
 * @param {string} currentLanguage - El idioma actual del usuario (ca, es, en)
 * @returns {string} - El idioma a usar para SEO (ca o es)
 */
export const getSEOLanguage = (currentLanguage) => {
    // Si es español, usar español para SEO
    if (currentLanguage === 'es') {
        return 'es';
    }

    // Si es catalán o inglés, usar catalán para SEO
    return 'ca';
};

/**
 * Obtiene el texto traducido para SEO según la lógica de idioma SEO
 * @param {function} t - Función de traducción del contexto de idioma
 * @param {string} currentLanguage - El idioma actual del usuario
 * @param {string} key - La clave de traducción
 * @returns {string} - El texto traducido según la lógica SEO
 */
export const getSEOText = (t, currentLanguage, key) => {
    const seoLanguage = getSEOLanguage(currentLanguage);

    // Temporalmente cambiar el idioma para obtener la traducción correcta
    // Nota: Esta función asume que t() puede acceder a todas las traducciones
    // Si no, necesitaremos importar las traducciones directamente

    return t(key);
};
